<template lang="pug">
v-card.pause-today(v-if="model" elevation="0")
    v-card-text
        v-btn.mb-3(:color="model.isActive ? 'warning' : 'primary'" :loading="loading" @click="set")
            template(v-if="model.isActive") {{$t('labels.deactivate')}}
            template(v-else) {{$t('labels.activate')}}

        p.g-73--text {{ $t('texts.not_receive_order_until_activate') }}
</template>

<script>
import RestaurantsApiClient from '@/api/RestApi/RestaurantsApiClient'
import { EventBus } from '@/plugins/events'

export default {
    props: {
        model: null,
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        set() {
            this.loading = true
            if (this.model.isActive)
                RestaurantsApiClient.inactivateForToday(this.model.id)
                    .then(() => {
                        EventBus.$emit('reloadRestaurant')
                    })
                    .finally(() => {
                        this.loading = false
                    })
            else
                RestaurantsApiClient.activate(this.model.id)
                    .then(() => {
                        EventBus.$emit('reloadRestaurant')
                    })
                    .finally(() => {
                        this.loading = false
                    })
        },
    },
}
</script>
